require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-162-exporting-importing-to-procore.json") })
        }
      }, "path---article-162-exporting-importing-to-procore");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-162-exporting-importing-to-procore!./.cache/json/article-162-exporting-importing-to-procore.json
// module id = 510
// module chunks = 231608221292675